import { TEN_MINUTES_IN_MS } from '@/constants';
import { DEFAULT_IFRAME_TIMEOUT_MS } from '@azure/msal-browser';
import { QueryClient } from '@tanstack/vue-query';

const queryClientConfig = {
    defaultOptions: {
        queries: {
            staleTime: TEN_MINUTES_IN_MS,
            timeout: DEFAULT_IFRAME_TIMEOUT_MS,
            retry: false,
        },
    },
};

export const queryClient = new QueryClient(
    queryClientConfig as unknown as ConstructorParameters<typeof QueryClient>[0]
);
